import { useNavigate } from 'react-router-dom';
import { STYLES, STYLE_ORDER } from '../data/styles';

export function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="space-y-10">
      {/* Hero */}
      <div className="text-center py-8">
        <h1 className="text-4xl sm:text-5xl font-bold text-brand leading-tight">
          Discover Your Social Style
        </h1>
        <p className="mt-4 text-lg text-brand-slate max-w-2xl mx-auto leading-relaxed">
          A 24-question behavioral assessment to help you understand how you communicate,
          collaborate, and lead. Based on the proven Social Style model by Merrill &amp; Reid.
        </p>
        <button
          onClick={() => navigate('/quiz')}
          className="
            mt-8 inline-flex items-center gap-2
            px-8 py-4 rounded-xl bg-scarlet text-white font-semibold text-lg
            hover:bg-scarlet-dark active:bg-scarlet-dark
            focus:outline-none focus:ring-2 focus:ring-scarlet/40 focus:ring-offset-2
            transition-colors duration-150 shadow-lg
          "
        >
          Start the assessment
          <span aria-hidden>→</span>
        </button>
        <p className="mt-3 text-sm text-brand-slate/60">Takes about 5 minutes · 24 questions</p>
      </div>

      {/* How it works */}
      <div className="bg-white rounded-xl border border-cream/40 shadow-sm p-6 sm:p-8">
        <h2 className="text-lg font-semibold text-brand mb-5">How it works</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {[
            {
              step: '1',
              title: 'Answer 24 questions',
              description:
                'For each item, choose the one word that feels most like you. There are no right or wrong answers.',
            },
            {
              step: '2',
              title: 'Get your profile',
              description:
                'See your dominant and backup Social Styles with detailed descriptions, strengths, and insights.',
            },
            {
              step: '3',
              title: 'Share and apply',
              description:
                'Share your results with colleagues and use your insights to improve communication and teamwork.',
            },
          ].map(({ step, title, description }) => (
            <div key={step} className="flex flex-col items-start">
              <div className="w-8 h-8 rounded-full bg-brand text-white text-sm font-bold flex items-center justify-center mb-3">
                {step}
              </div>
              <h3 className="font-semibold text-brand mb-1">{title}</h3>
              <p className="text-sm text-brand-slate leading-relaxed">{description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Style preview */}
      <div>
        <h2 className="text-lg font-semibold text-brand mb-4">The four Social Styles</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {STYLE_ORDER.map((key) => {
            const style = STYLES[key];
            return (
              <div
                key={key}
                className="rounded-xl border-l-4 bg-white shadow-sm p-5"
                style={{ borderLeftColor: style.color }}
              >
                <p className="font-bold text-brand">
                  {style.name}{' '}
                  <span className="font-normal text-brand-slate text-sm">{style.nickname}</span>
                </p>
                <p className="text-sm text-brand-slate mt-1 leading-relaxed">
                  {style.traits.slice(0, 4).join(' · ')}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Assumptions */}
      <div className="bg-cream/10 rounded-xl p-6 text-sm text-brand-slate leading-relaxed">
        <p className="font-semibold text-brand mb-2">Keep in mind</p>
        <p>
          No style is better or worse than another — each has genuine advantages. Most people have
          a predominant style but can access others. This assessment measures observable behavioral
          patterns, not your entire personality.
        </p>
      </div>
    </div>
  );
}
